<template>
  <!-- 上传出库单 -->
  <el-dialog class="dialog-qrcode" :title="''" :visible.sync="dialogVisible" width="600px">
    <div class="content">
      <h1 v-if="pageType==='1'">您可以使用手机拍摄纸质出库单，然后使用微信扫描下方二维码，从手机相册上传</h1>
      <h1 class="tc" v-if="pageType==='2'">使用微信扫描下方二维码</h1>

      <div class="pic_box tc">
        <img :src="qrUrl" alt>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      qrUrl: '',
      pageType: '1' // 1 藏品出库-上传出库单 2 社教活动-分享
    }
  },
  methods: {
    init(id, type) {
      this.qrUrl = ''
      this.pageType = type || '1'
      this.dialogVisible = true
      if (type === '1') {
        this.qrUrl = '/singleMuseum/output/getQrcode?outerId=' + id
      } else if (type === '2') {
        console.log(process.env.VUE_APP_ACTIVITY_URL)
        this.$http
          .get('/attach/createTwoDimensionCode', {
            content:
              process.env.VUE_APP_ACTIVITY_URL + '/#/activity/detail/' + id // 需要生成二维码的活动详情链接
          })
          .then(res => {
            this.loadingSave = false
            if (res.success) {
              this.qrUrl = res.result[0].attPath
            } else {
              this.$message.error(res.message)
            }
          })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-qrcode {
  .content {
    padding: 0 50px;
    .pic_box {
      height: 200px;
      img {
        width: 200px;
        height: 200px;
      }
    }
  }
}
</style>

